<template>
  <notification
    type="is-danger"
    icon="fa-search"
    :snackbar="5"
    @delete="$emit('delete')"
  >
    Szukan{{ _("yae") }} {{ resource.name }} nie został{{
      _(" ao")
    }}
    znalezion{{ _("yae") }}.
  </notification>
</template>

<script>
import { Notification } from "%notifications";

export default {
  name: "resource-not-found-notification",

  components: {
    Notification
  },

  props: {
    resource: {
      type: Object,
      default: () => ({
        name: "zasób",
        mode: "M"
      })
    }
  },

  methods: {
    _(letters) {
      return letters[
        {
          M: 0,
          F: 1,
          N: 2
        }[this.resource.mode]
      ].trim();
    }
  }
};
</script>

<style></style>
